import { useEffect, useState } from "react";

/**
 * Gibt `isDesktopView: true` zurück wenn das Browserfenster breiter als `minWidth` ist.
 * Standard-Breakpoint: 1024px (lg). Für XL-Layouts 1280px übergeben.
 */
const useScreenSize = (minWidth = 1024) => {
  const [isDesktopView, setDesktopView] = useState(
    typeof window !== "undefined" ? window.innerWidth >= minWidth : true
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setDesktopView(window.innerWidth >= minWidth);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [minWidth]);

  return { isDesktopView };
};

export default useScreenSize;
